import { lazy } from 'react';

const ClaimsLanding = lazy(() => import('../containers/pages/ClaimsLanding'));
const ClaimDetails = lazy(() => import('../containers/pages/ClaimDetails'));
const ClaimAnswers = lazy(() => import('../containers/pages/ClaimAnswers'));
const ClaimDetailsDocument = lazy(() => import('../containers/pages/ClaimDetailsDocument'));
const ClaimSubmitted = lazy(() => import('../containers/pages/ClaimSubmitted'));
const ClaimSelectorInitial = lazy(() => import('../containers/pages/ClaimSelectorInitial'));
const ClaimSelector = lazy(() => import('../containers/pages/ClaimSelector'));
const FNOLSections = lazy(() => import('../containers/pages/FNOLSections'));
const PreDocumentUploadPage = lazy(() => import('../containers/pages/FNOLDocumentsUploader'));
const EmailPage = lazy(() => import('../containers/pages/Email'));
const PayoutPage = lazy(() => import('../containers/pages/Payout/PayoutPage'));
const PayoutSubmitted = lazy(() => import('../containers/pages/Payout/PayoutSubmittedPage'));

export const routes = [
  {
    key: 'claimsLanding',
    path: '/claims',
    exact: true,
    component: ClaimsLanding,
  },
  {
    key: 'claimSubmitted',
    path: '/claims/fnol/submitted',
    exact: true,
    component: ClaimSubmitted,
  },
  {
    key: 'claimSelectorInitial',
    path: '/claims/fnol/claim-selector',
    exact: true,
    component: ClaimSelectorInitial,
  },
  {
    key: 'claimSelector',
    path: '/claims/fnol/claim-selector/:decisionPointId',
    exact: true,
    component: ClaimSelector,
  },
  {
    key: 'fnolSections',
    path: '/claims/fnol/sections/:sectionNames(.*)?',
    component: FNOLSections,
  },
  {
    key: 'PreDocumentUploadPage',
    path: '/claims/fnol/documents/:documentName',
    exact: true,
    component: PreDocumentUploadPage,
  },
  {
    key: 'claimDetails',
    path: '/claims/:claimReference/details',
    exact: true,
    component: ClaimDetails,
  },
  {
    key: 'claimDetailsAnswers',
    path: '/claims/:claimReference/details/answers',
    exact: true,
    component: ClaimAnswers,
  },
  {
    key: 'claimDetailsDocument',
    path: '/claims/:claimReference/documents/:documentName',
    exact: true,
    component: ClaimDetailsDocument,
  },
  {
    key: 'email',
    path: '/claims/:claimReference/emails/:id',
    exact: true,
    component: EmailPage,
  },
  {
    key: 'emailLegacy',
    path: '/claims/emails/:id',
    exact: true,
    component: EmailPage,
  },
  {
    key: 'payoutSubmitted',
    path: '/claims/:claimReference/payout-submitted',
    exact: true,
    component: PayoutSubmitted,
    isPublic: true,
  },
  {
    key: 'payout',
    path: '/claims/:claimReference/payout/:payoutID',
    exact: true,
    component: PayoutPage,
    isPublic: true,
  },
];
